import { Box, Stack, Typography } from '@mui/material'
import { useMinimalsTheme } from '@tom-ui/ui'
import dayjs from 'dayjs'
import { observer } from 'mobx-react-lite'

interface IProps {
  itemCount: number
  startDate: Date
  pixelPerHour: number
}

export const CarrierVisitPlanningDateAxis = observer(
  ({ startDate, itemCount, pixelPerHour }: IProps) => {
    const theme = useMinimalsTheme()

    const today = dayjs().startOf('day')
    const dates = Array.from({ length: itemCount }, (_, index) =>
      dayjs(startDate).add(index, 'days'),
    )

    const gridItems = dates.map((date, index) => {
      const isToday = date.isSame(today, 'day')

      return (
        <Box
          key={'dates_' + index}
          sx={{
            borderRight: `1px solid ${theme.palette.divider}`,
            padding: theme.customSpacing.m,
            minWidth: 24 * pixelPerHour,
            maxWidth: 24 * pixelPerHour,
            boxSizing: 'border-box',
          }}
        >
          <Stack direction={'row'} spacing={1} alignItems={'center'}>
            <Typography variant='subtitle2'>{date.format('ddd')}</Typography>
            <Typography
              variant='subtitle2'
              sx={{
                backgroundColor: isToday ? theme.palette.grey[600] : 'transparent',
                color: isToday ? theme.palette.common.white : 'inherit',
                borderRadius: '50%',
                width: 24,
                height: 24,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {date.format('D')}
            </Typography>
          </Stack>

          <Stack direction='row' mt={1}>
            <Typography width='50%' variant='body2'>
              00:00
            </Typography>
            <Typography width='50%' variant='body2'>
              12:00
            </Typography>
          </Stack>
        </Box>
      )
    })

    return (
      <Stack direction='row' spacing={0}>
        {gridItems}
      </Stack>
    )
  },
)
